import React, { useEffect, useState } from 'react';

function Home() {
  const [htmlContent, setHtmlContent] = useState('');

  useEffect(() => {
    // index.html 가져오기
    fetch('/main/index.html')
      .then(response => response.text())
      .then(data => {
        setHtmlContent(data);
      });

    // CSS 링크를 head에 추가
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "/main/static/css/style.css"; // 반드시 절대 경로 사용
    link.type = "text/css";
    document.head.appendChild(link);

    // 언마운트 시 제거 (안정성 확보)
    return () => {
      document.head.removeChild(link);
    };
  }, []);

  return (
    <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
  );
}

export default Home;
